var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M20.5 14H.5v-2h20zm0-6H.5V6h20zm0-6H.5V0h20z"}));
}

Menu.defaultProps = {"width":"21","height":"14","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
